import { useQuery } from "@tanstack/react-query";
import { getPackageDetailsByTransactionId } from "apis";

export const getPackageDetailsByTransctionIdKey = (transctionId?: number) => {
  const key = ["get-package-deatils-by-transaction-id"];
  if (transctionId) {
    key.push(transctionId.toString());
  }
  return key;
};

const useGetPackageDetailsByTransactionId = ({
  transctionId,
  inclusionId,
}: {
  transctionId?: number;
  inclusionId?: number;
}) => {
  return useQuery(
    getPackageDetailsByTransctionIdKey(transctionId),
    () =>
      getPackageDetailsByTransactionId({
        transactionId: transctionId,
        inclusionId: inclusionId,
      }),
    {
      enabled: !!transctionId || !!inclusionId,
    }
  );
};

export default useGetPackageDetailsByTransactionId;
